import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getReferenciasProductos`, method: 'GET', body: null, token: token})
}